import { CustomerNote } from "../customer_note/CustomerNote"
import { ServiceFieldValueDetails } from "../service/ServiceFieldValueDetails"

export class CustomerOrderServiceDetails {
  completed: boolean
  description: string
  name: string
  notes: CustomerNote[]
  price: number
  serviceFieldValues: ServiceFieldValueDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(completed: boolean, description: string, name: string, notesJson: any, price: number, serviceFieldValuesJson: any) {
    this.completed = completed
    this.description = description
    this.name = name
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notesJson ? notesJson.map((n: any) => new CustomerNote(n.content)) : []
    this.price = price
    this.serviceFieldValues = serviceFieldValuesJson as ServiceFieldValueDetails[]
  }
}